<template>
  <div class="flex flex-col items-start text-white m-4">
    <div class="flex flex-row gap-2 items-center my-2">
      <button class="rounded-full bg-paleta-3" @click="volver">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            fill="currentColor"
            d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
          ></path>
        </svg>
      </button>
      <div class="text-white text-base">Cambiar contraseña</div>
    </div>

    <div class="mt-4">Contraseña anterior</div>
    <div class="text-gray-700"><input type="password" id="contrasenaAnterior" v-model="contrasenaAnterior" class="text-gray-800 p-1 w-full" /></div>
    <div class="mt-4">Nueva contraseña</div>
    <div><input type="password" id="contrasena1" v-model="contrasena1" class="text-gray-800 p-1 w-full" /></div>
    <div>Repetir nueva contraseña</div>
    <div><input type="password" id="contrasena2" v-model="contrasena2" class="text-gray-800 p-1 w-full" /></div>
    <div><button @click="cambiarContrasena" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Cambiar</button></div>
    <div v-if="mensajeErrorLocal || mensajeErrorCambioContrasena" class="text-white">
      {{ mensajeErrorLocal || mensajeErrorCambioContrasenao }}
    </div>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import { mapState } from "vuex";

export default {
  data() {
    return {
      contrasenaAnterior: "",
      contrasena1: "",
      contrasena2: "",
      mensajeErrorLocal: ""
    };
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    cambiarContrasena() {
      if (!this.contrasena1 || !this.contrasena2 || this.contrasena1 !== this.contrasena2) {
        this.mensajeErrorLocal = "Las contraseñas nuevas son distintas";
        return;
      }

      this.$store.dispatch("cambiarContrasena", {
        hashContrasenaAnterior: sha1(this.contrasenaAnterior),
        hashContrasenaNueva: sha1(this.contrasena1)
      });
    }
  },
  computed: {
    ...mapState({
      mensajeErrorCambioContrasena: state => state.sesion.mensajeErrorCambioContrasena
    })
  }
};
</script>
